var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardinalityOneMany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H20M16.5 16V23.5C16.5 24.6 17.4 25.5 18.5 25.5H20M16.5 16.25V8.75C16.5 7.65 17.4 6.75 18.5 6.75H20M11 19H8C6.9 19 6 18.1 6 17V15C6 13.9 6.9 13 8 13H11C12.1 13 13 13.9 13 15V17C13 18.1 12.1 19 11 19ZM24.8 18H21.2C20.54 18 20 17.46 20 16.8V15.2C20 14.54 20.54 14 21.2 14H24.8C25.46 14 26 14.54 26 15.2V16.8C26 17.46 25.46 18 24.8 18ZM24.8 27.5H21.2C20.54 27.5 20 26.96 20 26.3V24.7C20 24.04 20.54 23.5 21.2 23.5H24.8C25.46 23.5 26 24.04 26 24.7V26.3C26 26.96 25.46 27.5 24.8 27.5ZM24.8 8.5H21.2C20.54 8.5 20 7.95999 20 7.29999V5.70001C20 5.04001 20.54 4.5 21.2 4.5H24.8C25.46 4.5 26 5.04001 26 5.70001V7.29999C26 7.95999 25.46 8.5 24.8 8.5Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardinalityOneMany);
export default __webpack_public_path__ + "static/media/cardinality-one-many.79b1d3ed29d5f4d46fb68601d7f73514.svg";
export { ForwardRef as ReactComponent };